<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="二维码"
        width="400px"
        top="10vh">
      <div id="content">
        <div id="qrCode" ref="qrCodeDiv"/>
        <div id="no" style="margin-top: 5%">
          <span>
            设备名称：
          </span>
          <span>
            {{equipment.name}}
          </span>
        </div>
        <div style="margin-top: 1%">
          <span>
            设备编号：
          </span>
          <span>
            {{equipment.no}}
          </span>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="dialogVisible=false">关闭</el-button>
        <el-button @click="print">打印</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import QRCode from "qrcodejs2";
  import constant from "../../../util/constant";

  export default {
    name:"QRCode",
    components: {},
    data() {
      return {
        constant,
        dialogVisible: false,
        contentLoading: false,
        equipment: {
          pkid: "",
          no: "",
          name: "",
          model: "",
          location: "",
          dealer: "",
          purchaseDate: "",
          emRepairOrder: {
            urgency: "",
            result: "",
            status: "",
          },
        },
      };
    },
    methods: {
      open(row) {
        console.log(row);
        this.dialogVisible = true;
        this.$nextTick(() => {
          document.getElementById("qrCode").innerHTML = "";
          this.equipment.pkid = "";
          this.equipment.no = "";
          this.equipment.name = "";
          this.equipment.model = "";
          this.equipment.location = "";
          this.equipment.dealer = "";
          this.equipment.purchaseDate = "";
          this.equipment.emRepairOrder.urgency = "";
          this.equipment.emRepairOrder.result = "";
          this.equipment.emRepairOrder.status = "";
          this.getData(row.pkid);
        });
      },
      getData(id) {
        this.$http
          .get("basic", `equipments/${id}`)
          .then(resp => {
            console.log(resp);
            this.equipment.pkid = resp.pkid;
            this.equipment.no = resp.no;
            this.equipment.name = resp.name;
            this.equipment.model = resp.model;
            this.equipment.location = resp.location;
            this.equipment.dealer = resp.dealer;
            this.equipment.purchaseDate = resp.purchaseDate;
            if(resp.emRepairOrder!==null) {
              if (resp.emRepairOrder.urgency !== null) {
                this.equipment.emRepairOrder.urgency = constant.urgencyType[resp.emRepairOrder.urgency];
              }
              if (resp.emRepairOrder.status !== null) {
                this.equipment.emRepairOrder.status = constant.reportOrderStatus[resp.emRepairOrder.status];
              }
              if (resp.emRepairOrder.result !== null) {
                this.equipment.emRepairOrder.result = constant.result[resp.emRepairOrder.result];
              }
            }
            this.bindQRCode(this.equipment);
          });
      },
      bindQRCode(row) {
        let prams={
          pkid: row.pkid,
        };
        new QRCode(this.$refs.qrCodeDiv, {
          text: JSON.stringify(prams),
          width: 200,
          height: 200,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L,//容错率，L/M/H
        });
      },
      print() {
        document.body.innerHTML = document.getElementById("content").innerHTML;
        window.print();
        window.location.reload();
        return false;
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
